export const PortalNames = {
    Partner: { Name: "PARTNER", Path: "ap3" },
    Broker: { Name: "BROKER", Path: "broker" },
    Employer: { Name: "EMPLOYER", Path: "erui" },
    Employee: {
        Name: "EMPLOYEE",
        Path: "eeui",
        Pages: {
            Dashboard: "dashboard",
            Messages: "messages",
            TimeSheet: "timesheet",
            Hourbank: "hourbank",
            Excess: "excess",
            Benefits: "benefits",
            HWStatements: "hwstatements",
            Files: "files",
            Feedback: "feedback",
        }
    },
    Contractor: { Name: "CONTRACTOR", Path: "contractor" },
    CollectionPartner: { Name: "COLLECTION", Path: "cui" },
    CollectionCompany: { Name: "COLLECTION-COMPANY", Path: "ccui" },
    CollectionVendor: { Name: "COLLECTION-VENDOR", Path: "cvui" },
}

export const Portals = [
    { Portal: PortalNames.Partner.Name,  Path: `/${PortalNames.Partner.Path}/dashboard`,  Roles:['ADMIN-SYS-ADMIN','ADMIN-SYS-MANAGER','PARTNER'], Label: 'Partner' },
    { Portal: PortalNames.Broker.Name,   Path: `/${PortalNames.Broker.Path}/dashboard`,   Roles:['ADMIN-SYS-ADMIN','ADMIN-SYS-MANAGER','BROKER'], Label: 'Broker' },
    { Portal: PortalNames.Employer.Name, Path: `/${PortalNames.Employer.Path}/dashboard`, Roles:['ADMIN-SYS-ADMIN','ADMIN-SYS-MANAGER','EMPLOYER'], Label: 'Employer' },
    { Portal: PortalNames.Employee.Name, Path: `/${PortalNames.Employee.Path}/${PortalNames.Employee.Pages.Dashboard}`,  Roles:['EMPLOYEE','USER-EMPLOYEE'], Label: 'Employee' },
    { Portal: PortalNames.Employee.Name, Path: `/${PortalNames.Employee.Path}/logout`,    Roles:['ADMIN-SYS-ADMIN','ADMIN-SYS-MANAGER'], Label: 'Employee - Logout then Login as EE User' },
    { Portal: PortalNames.Contractor.Name, Path: `/${PortalNames.Contractor.Path}/dashboard`,    Roles:['CONTRACTOR'], Label: 'Contractor' },
    { Portal: PortalNames.CollectionPartner.Name, Path: `/${PortalNames.CollectionPartner.Path}/dashboard`,    Roles:['COLLECTION-PARTNER'], Label: 'Collection Partner' },
    { Portal: PortalNames.CollectionCompany.Name, Path: `/${PortalNames.CollectionCompany.Path}/dashboard`,    Roles:['COLLECTION-COMPANY'], Label: 'Collection Company' },
    { Portal: PortalNames.CollectionVendor.Name, Path: `/${PortalNames.CollectionVendor.Path}/dashboard`,    Roles:['COLLECTION-VENDOR'], Label: 'Collection Vendor' },
]